<template>
  <div>
    <!--工具条-->
    <el-col :span="24">
      <el-form :inline="true" :model="filters" @submit.native.prevent>
        <el-form-item>
          <el-input size="small" v-model="filters.roleName" placeholder="角色名" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" v-on:click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-col :span="24"  v-loading="loading"  element-loading-text="拼命加载中" style="height: 355px">
      <!--列表-->
      <el-table :data="role" height="356" ref="multipleTable" @selection-change="selectionChange" :row-key="getRowKeys">
        <el-table-column type="selection" :reserve-selection="true" min-width="7"></el-table-column>
        <el-table-column prop="roleName" label="角色名" min-width="50" ></el-table-column>
        <el-table-column prop="companyName" label="所属企业">
          <template slot-scope="scope">{{scope.row.isPlatformRole===1?'大中管理平台':scope.row.companyName}}</template>
        </el-table-column>
        <el-table-column prop="status" label="是否平台角色">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.isPlatformRole === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row.isPlatformRole===1?'是':'否'}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-col>

    <div>
      <el-pagination
        style="float:right;"
        layout="prev, pager, next"
        background @current-change="handleCurrentChange"
        :page-size="limit"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import API from '@/api/api_role';
import DIC_API from '@/api/api_dictionary';

export default {
  data() {
    return {
      filters: {
        roleName: ''
      },
      role: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,

      isSelectionIn: false,

      enterpriseId: undefined
    }
  },

  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = Object.assign({
        page: that.page,
        limit: 10,
        enterpriseId: this.enterpriseId
      }, that.filters);

      that.loading = true;
      API.findList(params).then(function(result) {
        that.loading = false;
        if (result && result.rows) {
          that.total = result.total;
          that.role = result.rows;
        }
      }, function(err) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: err.toString(),
          duration: 2000
        });
      }).catch(function(error) {
        that.loading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    selectionChange(e) {
      this.selectDataList = [];
      if (e) {
        e.forEach(obj => {
          let roleName = obj.roleName;
          if (!roleName.startsWith('「角色」')) {
            roleName = '「角色」' + roleName;
          }
          this.selectDataList.push({
            key: obj.id,
            label: roleName,
            personType: "3"
          })
        })
      }
      if (!this.isSelectionIn) {
        this.$emit("selection-change", this.selectDataList);
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    setSelection(rows) {
      this.isSelectionIn  = true;
      if (this.selectDataList) {
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection({
            key: row.key,
            id: row.key,
            label: row.label,
            roleName: row.label
          });
        });
        this.tableReload();
      }
      this.isSelectionIn = false;
    },
    tableReload() {
      this.role = JSON.parse(JSON.stringify(this.role));
    }
  },
  mounted() {
    this.handleSearch();
    let userInfo = JSON.parse(localStorage.getItem('userinfo'));
    this.enterpriseId = userInfo.enterpriseId;
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/trainingManagement/component/user/roleSelection.vue